// extracted by mini-css-extract-plugin
export default {"defaultCloseButton":"w2S45IP5"};